(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/betslip-expanded.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/betslip-expanded.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BetslipExpanded = Backbone.Model.extend({
    defaults: {
      amount: 1,
      overviewOpen: false
    },

    initialize: function() {
      var competitionMode =
        svs.tipset.models.competition &&
        svs.tipset.models.competition.getCompetitionMode()
          ? svs.tipset.models.competition.getCompetitionMode()
          : false;
      this.listenTo(
        svs.tipset.models.bombenXperten,
        'bombenSet bombenRemoved',
        this.updateBomben
      );
      this.set(
        {
          rowPrices: svs.tipset.models.gameDefinitions.get('rowPrices'),
          isInCompetitionMode: competitionMode
        },
        { silent: true }
      );
    },

    setAmount: function(newAmount) {
      this.set('amount', newAmount);
    },

    onBetAmountChanged: function(newAmount) {
      this.set('amount', newAmount);
      this.save();
    },

    toggleOverviewOpen: function() {
      var isOverviewOpen = this.get('overviewOpen');
      this.set('overviewOpen', !isOverviewOpen);
    },

    updateBomben: function() {
      this.set({
        showBombenBetslipInfo:
          svs.tipset.models.bombenXperten &&
          svs.tipset.models.bombenXperten.get('hasXpertValues')
      });
    },

    save: function() {
      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    },

    onAccountChangeBetslipExpanded: function() {
      this.trigger('updateAccount');
    },

    setAccountListener: function() {
      if (
        svs.components.marketplace &&
        svs.components.marketplace.accountSelector
      ) {
        this.onAccountChangeBetslipExpanded = this.onAccountChangeBetslipExpanded.bind(
          this
        );
        svs.components.marketplace.accountSelector.helpers.observer.subscribe(
          this.onAccountChangeBetslipExpanded
        );
      }
    }
  });
})(Backbone, _, svs);

 })(window);